skrilla.controller('errorModalCtrl', function ($scope, cacheService, modalService) {
    $scope.showDetails = false;
    $scope.error = cacheService.getObject("errorResponse");

    $scope.close = modalService.dismissAll;

});